export const wordpressGroups = {
  "blog": {
    name: "Dimension Blog",
  },
  "materials": {
    name: "Materials",
  },
  "recycling": {
    name: "Recycling",
  },
  "business": {
    name: "B2b Solutions",
  },
  "case-studies": {
    name: "Case Study",
  },
};

export const wordpressPostIds: { [key: string]: string } = {
  "waste-streams": "183",
  "improve-diversion": "198",
  "b2b-solutions": "203",
  "service-provider-policy": "320",
  "privacy-policy": "1012",
  "provider-agreement": "1257",
  "slack": "1022",
  "instacart-landing": "1064",
  "in-the-news": "1112",
  "freefirsttrial": "1273",
  "freefirsttrial_success": "1276",
  "terms": "1385",
};

export const wordpressCategoryIds: { [key: string]: number } = {
  blog: 1382,
  materials: 1385,
  recycling: 1389,
  business: 1372,
};